import { Job, PipeProgress } from "../job/state/job.model";

export class BusEvent {
  // TODO: Maybe there are some interfaces eventually
}

export class HomingPigeonRequest extends BusEvent {
  constructor(
    public authorization: string,
    public tenant: string,
    public channel: string,
    public action: HomingPigeonAction,
    public message?: any,
  ) {
    super();
  }
}

export class HomingPigeonMessage extends BusEvent {
  public type: string;
  public tenant: string;
  public channel: string;
  public body: any;
}

export class IQError {
  public status_code: number;
  public type: string;
  public service: string;
  public user_message: string;
  public traceback: string;
}

export class IQErrorMessage extends HomingPigeonMessage {
  public body: IQError;
}

export class JobStatusMessage extends HomingPigeonMessage {
  public body: {
    job: Job;
    status: string;
  };
}

export class JobProgressMessage extends HomingPigeonMessage {
  public body: {
    job: Job;
    pipe: string;
    progress: PipeProgress;
  };
}

export enum HomingPigeonAction {
  JOIN = "join",
  LEAVE = "leave",
  SEND = "send",
  HEARTBEAT = "heartbeat",
}

export enum Channel {
  TENANT = "tenant", // The default bus for a workspace
}

export enum HomingPigeonType {
  ERROR = "error",
}

export enum EventType {
  JOB_STATUS = "job-status",
  JOB_PROGRESS = "job-progress",
  DATA_SOURCE_CREATED = "data-source-created",
  DATA_SOURCE_UPDATED = "data-source-updated",
  DATA_SOURCE_DELETED = "data-source-deleted",
  MODEL_CREATED = "model-created",
  MODEL_UPDATED = "model-updated",
  MODEL_OBSOLETE = "model-obsolete",
  MODEL_DELETED = "model-deleted",
  MODEL_VERSION_CREATED = "model-version-created",
  MODEL_VERSION_RELEASED = "model-version-released",
  MODEL_VERSION_UPDATED = "model-version-updated",
  MODEL_VERSION_DELETED = "model-version-deleted",
  CHAT_SESSION_DELETED = "chat-session-deleted",
  PERSISTENT_NOTIFICATION_CREATED = "persistent-notification-created",
  PIPELINE_UPDATED = "pipeline-updated",
}
